import { BucketSize } from '@/api-client/models/indoorclimate/Contracts'
import { intervalToDuration } from 'date-fns'

const areAllZero = (...values: number[]): boolean => values.every((val) => val === 0)

export const calculateBucketSizes = (from: string, to: string): BucketSize[] => {
  const fromDate = new Date(from)
  const toDate = new Date(to)
  const { years = 0, months = 0, days = 0 } = intervalToDuration({ start: fromDate, end: toDate })

  if (areAllZero(years, months) && days <= 1) return ['HOUR', 'MINUTE_10']
  if (days <= 7 && areAllZero(years, months)) return ['DAY', 'HOUR']
  if (months <= 1 && areAllZero(years)) return ['WEEK', 'DAY']
  if (months <= 3 && areAllZero(years)) return ['MONTH', 'WEEK', 'DAY']
  if (months <= 6 && areAllZero(years)) return ['MONTH', 'WEEK']
  if (years === 0) return ['QUARTER', 'MONTH', 'WEEK']

  return ['YEAR', 'QUARTER', 'MONTH']
}
